/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_CarInputs */

const en_homepage_listen_in_car = /** @type {(inputs: Homepage_Listen_In_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In The Car`)
};

const es_homepage_listen_in_car = /** @type {(inputs: Homepage_Listen_In_CarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En el coche`)
};

/**
* | output |
* | --- |
* | "In The Car" |
*
* @param {Homepage_Listen_In_CarInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_car = /** @type {((inputs?: Homepage_Listen_In_CarInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_CarInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_car(inputs)
	return en_homepage_listen_in_car(inputs)
});